import { CLOCK } from '../engine/constants.js';

export function S(n, title, teca, speech, action, screen, extra = {}) {
  const slide = {
    n,
    title,
    teca,
    speech,
    prompt: extra.prompt ?? null,
    action,
    screen,
    beat: CLOCK[n],
    nexo: Boolean(extra.nexo),
    vaza: Boolean(extra.vaza),
    orientation: extra.orientation ?? null,
    scored: extra.scored ?? null,
    explain: extra.explain ?? null,
    example: extra.example ?? null,
    why: extra.why ?? null,
    terms: extra.terms ?? null,
    learn: extra.learn ?? null,
    kicker: extra.kicker ?? null,
  };
  if (extra.tips) slide.tips = extra.tips;
  return slide;
}

export function singleQuiz({
  items,
  options,
  correct,
  gabaritoCerto,
  gabaritoErrado,
}) {
  return {
    type: 'single',
    items: items.map((id) => ({ id, kind: 'single', correct })),
    options,
    gabaritoCerto,
    gabaritoErrado: gabaritoErrado || gabaritoCerto,
  };
}

export function multiQuiz({ items, options, gabaritoCerto, gabaritoErrado }) {
  return {
    type: 'multi',
    items,
    options,
    gabaritoCerto,
    gabaritoErrado: gabaritoErrado || gabaritoCerto,
  };
}

export function opt(id, text) {
  return { id, text };
}
